import config from "../config";

// FIXME: replace cordova usage

const insomnia = {
  start: () => {
    if (config.isApp && !config.hasFakeAppArgument) {
      console.info("insomnia mode activated");
      // window.plugins.insomnia.keepAwake();
    }
  },
  stop: () => {
    if (config.isApp && !config.hasFakeAppArgument) {
      // window.plugins.insomnia.allowSleepAgain();
      console.info("insomnia mode disabled");
    }
  },
};
export default insomnia;
